import React from 'react';
import SnippetManager from './SnippetManager';
import '@questlabs/react-sdk/dist/style.css';

function App() {
  return (
    <div className="bg-gray-950 min-h-screen">
      <SnippetManager />
    </div>
  );
}

export default App;